<div class="range-dropdown-filter" [formGroup]="form">
    <select formControlName="selected">
        <option [ngValue]="null"></option>
        @for (opt of options; track opt) {
            <option [ngValue]="opt">
                {{ opt.label }}
            </option>
        }
    </select>
</div>
